module.exports = __webpack_public_path__ + "img/flatbed-semi-trailer.918de9c.png";